<div class="row">
  <div class="col">
    <h1>{{headline}}</h1>
    <p>
      {{content}} <ng-content></ng-content>
    </p>
  </div>
</div>

